import React, { useState, useEffect } from "react";
import { Button, TextField, IconButton } from "@mui/material";
import { getAPI } from "../../Global";
import DynamicAutocomplete from "../../utils/DynamicForm/DynamicAutocomplete";
import FormField from "../../utils/Crud-Manager/FormField";
import RadioButtonsGroup from "../../utils/Crud-Manager/Radiobutton";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../Assets/Styles/Style.css";
import DescriptionInvestment from "./DescriptionInvestment";
import Transaction from "../../components/descriptionshow/Transaction";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import PrintComponent from "./PrintComponent";
import useApi from "../../utils/useApi";

function ManualTransaction() {
  const [value, setValue] = useState("");
  const [data, setData] = useState(null);
  const [amount, setAmount] = useState(0);
  const [invId, setInvId] = useState(null);
  const [invNo, setInvNo] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(0);
  const [totalMonths, setTotalMonths] = useState(0);
  const [passedMonth, setPassedMonth] = useState(0);
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [groupTitle, setGroupTitle] = useState("");
  const [subscriptionNo, setSubscriptionNo] = useState("");

  const { Get, Post, Patch } = useApi();

  const [printData, setPrintData] = useState(null);
  const counterStyle = {
    margin: "5px",
    padding: "5px",
    border: "2px solid #bfbfbf",
  };
  useEffect(() => {}, []);
  function handleSubmit(e) {
    e.preventDefault();
    var data = new FormData(e.target);
    let formData = Object.fromEntries(data.entries());
    const description = `Paid Via  Cash ${subscriptionNo} of ${groupTitle}.`;
    formData.description = description;
    formData.transaction_at = new Date();
    formData.is_cash = true;
    // Debugging log

    if (formData.selectedMonth > totalMonths - passedMonth) {
      toast.error(`Maximum allow month are ${totalMonths - passedMonth}`);
      return;
    }

    Post(getAPI("transaction"), formData)
      .then((response) => {
        const {
          voucher,
          group_title,
          subscription_no,
          user_full_name,
          amount,
        } = response.data;
        setPrintData({
          ...formData,
          group_title,
          subscription_no,
          user_full_name,
          amount,
          voucher,
        });
        // setPrintData(formData);
        toast.success("Transaction successful");
      })
      .catch((error) => {
        toast.error("Error during transaction");
      });
  }
  const getDataUsingInvNo = async (invNo) => {
    try {
      const getInvestmentDetails = await Get(
        `${getAPI("getTransactionsByInvestmentNo")}${invNo}/`
      );

      const investmentId = getInvestmentDetails.investment_info.id;
      const nextDueResponse = await Get(
        `${getAPI("getInvestmentNextDue")}${investmentId}/`
      );
      const combinedData = {
        ...getInvestmentDetails,
        due_summary: nextDueResponse.due_summary,
        investment_info: nextDueResponse.investment_info,
      };
      setDisableSubmit(false);
      setData(combinedData);
      setInvNo(combinedData.investment_info.investment_id);
      setInvId(investmentId);
      setTotalMonths(combinedData.investment_info.total_month);
      setGroupTitle(combinedData.group_info.title);
      setSubscriptionNo(combinedData.subscription_no);
      setPassedMonth(combinedData.investment_info.total_passed_months);
      if (combinedData.due_summary && combinedData.due_summary.payable_amt) {
        setAmount(combinedData.due_summary.payable_amt);
      }
    } catch (error) {
      toast.error(`No Investment found with number ${invNo}`);
      setData(null);
      setValue("");
      setData(null);
      setAmount(0);
    }
  };
  const handleButtonClick = () => {
    try {
      let elements = document.forms["investmentForm"]["_investment"].value;
      getDataUsingInvNo(elements);
    } catch {
      toast.warn("Please select User and Investment first!");
    }
  };
  // month
  const getAmountByMonth = async (month) => {
    try {
      const getInvestmentDetails = await Get(
        `${getAPI("getTransactionsByInvestmentNo")}${invNo}/`
      );
      // console.log(data);
      const response = await Get(
        `${getAPI("getInvestmentNextDue")}${invId}/?month=${month}`
      );
      const combinedData = {
        ...getInvestmentDetails,
        due_summary: response.due_summary,
        investment_info: response.investment_info,
      };
      setData(combinedData);
      setTotalMonths(combinedData.investment_info.total_month);
      setPassedMonth(combinedData.investment_info.total_passed_months);
      if (combinedData.due_summary && combinedData.due_summary.payable_amt) {
        setAmount(combinedData.due_summary.payable_amt);
      }
    } catch (error) {
      toast.error(`Failed to fetch amount for month ${month}`);
    }
  };
  const handleMonthChange = (newMonth) => {
    if (newMonth == 0) {
      try {
        let elements = document.forms["investmentForm"]["_investment"].value;
        getDataUsingInvNo(elements);
      } catch {
        toast.warn("Please select User and Investment first!");
      }
    }
    if (newMonth >= 1 && newMonth <= totalMonths - passedMonth) {
      setSelectedMonth(newMonth);
      getAmountByMonth(newMonth);
    }
  };
  const handleInputChange = (event) => {
    setValue(event.target.value);
  };
  const Styles = {
    marginTop: "10px",
    marginBottom: "10px",
    width: "100%",
    // margin: "8px",
    width: "100%",
  };
  const inputStyles = {
    fontSize: "25px",
    fontWeight: "bold",
  };
  return (
    <div className="row">
      <div
        className="col-md-12"
        style={{ width: "100vw", marginBottom: "10px" }}
      ></div>
      <div className="col-md-8">
        <form onSubmit={handleSubmit} name="investmentForm">
          <div className="row">
            <div
              className="col-md-8"
              style={{ borderRight: "5px solid #bfbfbf" }}
            >
              {/* <div className="row"> */}
              <DynamicAutocomplete
                fields={[
                  {
                    apiUrl: getAPI("user"),
                    displayKey: "phone_no",
                    valueKey: "id",
                    name: "user",
                    label: "User",
                    variant: "standard",
                    advance: true,
                  },
                  {
                    apiUrl: getAPI("getInvestmentsByUserId"),
                    displayKey: "investment_id",
                    valueKey: "id",
                    name: "investment",
                    parent: "user",
                    parent_value_key: "id",
                    label: "Investments",
                    variant: "standard",
                    sameAsSeen: true,
                    advance: true,
                  },
                ]}
              />
            </div>
            {data && (
              <div className="col-md-4">
                <span
                  style={{
                    // textAlign: "center",
                    fontSize: "20px",
                    fontFamily: "Comfortaa",
                    position: "absolute",
                    left: "5px",
                    fontWeight: "bold",
                  }}
                >
                  {data.user_info.full_name}
                  <br />
                  <strong
                    style={{
                      textAlign: "center",
                      fontSize: "20px",
                      fontFamily: "Comfortaa",
                      position: "absolute",
                      left: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    {data.investment_info.user_phone}
                  </strong>
                </span>
              </div>
            )}
          </div>
          {/* </div> */}
          <div className="row">
            <div className="col-md-12">
              {" "}
              <Button variant="outlined" onClick={handleButtonClick}>
                <i className="fa fa-search"></i>&nbsp;Get User Details
              </Button>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <DynamicAutocomplete
                fields={[
                  {
                    apiUrl: getAPI("account"),
                    displayKey: "name",
                    valueKey: "id",
                    name: "account",
                    label: "Account",
                    variant: "standard",
                    advance: true,
                    defaultObj: {
                      id: 2,
                      name: "Cash",
                      description: "Cash",
                    },
                  },
                ]}
              />
            </div>
            <div className="col-md-3">
              {data ? (
                <div
                  style={{
                    marginTop: "5px",
                    fontSize: "12px",
                    color: "#8A8787",
                  }}
                >
                  {disableSubmit ? (
                    <span style={{ color: "red" }}>
                      Max {totalMonths - passedMonth} months allowed!
                    </span>
                  ) : (
                    "Month"
                  )}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <IconButton
                      onClick={() => handleMonthChange(selectedMonth - 1)}
                      disabled={selectedMonth <= 1}
                      style={counterStyle}
                    >
                      <RemoveIcon />
                    </IconButton>
                    <input
                      name="selectedMonth"
                      style={{
                        border: "2px solid #bfbfbf",
                        borderRadius: "20px",
                        width: "50px",
                        paddingLeft: "18px",
                      }}
                      maxlength={totalMonths - passedMonth}
                      onChange={(e) => {
                        if (e.target.value > totalMonths - passedMonth) {
                          setDisableSubmit(true);
                        } else {
                          setDisableSubmit(false);
                        }
                        setSelectedMonth(e.target.value);
                      }}
                      onBlur={() => handleMonthChange(selectedMonth)}
                      value={selectedMonth}
                      type="number"
                      variant="standard"
                      label="Month"
                    />
                    <IconButton
                      onClick={() => handleMonthChange(selectedMonth + 1)}
                      disabled={selectedMonth >= totalMonths - passedMonth}
                      style={counterStyle}
                    >
                      <AddIcon />
                    </IconButton>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="col-md-3">
              <TextField
                label="Amount"
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                variant="standard"
                name="amount"
                style={{
                  width: "100%",
                }}
                InputProps={{
                  style: inputStyles,
                }}
              />
            </div>
            <input
              hidden
              name="transaction_type"
              value="subscription_amt"
              type="text"
            />
            <div className="col-md-3">
              <Button
                type="submit"
                variant="contained"
                disabled={disableSubmit}
              >
                Save
              </Button>
            </div>
          </div>
        </form>
        <hr />
        {data && <DescriptionInvestment data={data} />}
      </div>
      <div className="col-md-4">
        {data && <Transaction data={data} height={"480px"} />}
      </div>
      {printData && <PrintComponent formData={printData} />}
    </div>
  );
}
export default ManualTransaction;
